import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bodyClass:'',
    locale:'en'
  },
  mutations: {
    changeFont (state, fontClass) {
      state.bodyClass = fontClass;
    },
    setLocale(state,locale){
      state.locale = locale;
    }
  },
  actions: {
  },
  modules: {
  }
})
